/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */
export function arrayContainsArray(superset, subset) {
  if (!Array.isArray(superset)) {
    throw new TypeError(`superset is not Array ${superset}`);
  }
  if (!Array.isArray(subset)) {
    throw new TypeError(`subset is not Array ${subset}`);
  }
  return subset.every(value => (superset.indexOf(value) >= 0));
}
